<template>
	<div class="situation">
		<div class="accident">
			<div class="tip">安全事故名称</div>
			<div class="input">
				<input type="text" maxlength="50" v-model="accidentName" placeholder="请输入" />
			</div>
		</div>
		<div class="accident">
			<div class="tip">事故级别</div>
			<div class="drop_down" @click="showQuarter">
				<span v-if="!selectQuarter.text">请选择</span>
				<span class="selected" v-if="selectQuarter.text">{{ selectQuarter.text }}</span>
				<img src="@/assets/appraise/arrow_right.png" alt />
			</div>
		</div>
		<div class="accident">
			<div class="tip">发生时间</div>
			<div class="drop_down" @click="showTime">
				<span v-if="!selectTime.value">请选择</span>
				<span v-if="selectTime.value" class="selected">{{ selectTime.name }}</span>
				<img src="@/assets/appraise/arrow_right.png" alt />
			</div>
		</div>
		<div class="link">
			<div class="link_title">事故处理情况</div>
      <div class="about_content">
        <textarea class="content" placeholder="请输⼊事故处理情况" maxlength="500" v-model="accidentDesc"></textarea>
    </div>
		</div>
		<div class="upload_file">
			<div class="upload_tit">相关材料</div>
			<div class="file_item" v-for="item in fileResVOS" :key="item.id">
				<div class="file_msg">
					<img v-if="item.fileType === 'exl'" src="@/assets/appraise/ic_exl.png" alt />
					<img v-if="item.fileType === 'doc'" src="@/assets/appraise/ic_doc.png" alt />
					<img v-if="item.fileType === 'pdf'" src="@/assets/appraise/ic_pdf.png" alt />
					<p class="file_name">
						<span>{{ item.fileName }}</span>
					</p>
				</div>
				<div class="delImg" @click="del(item)">
					<img src="@/assets/appraise/delete.png" alt />
				</div>
				<div class="file_size">{{ item.fileSize }}</div>
			</div>
			<addBtn v-if="fileResVOS.length < 10" :imgUrl="[]" :isShowSpan="true" :isGoAndroidandIOS="true" :needEmit="true" @fields="getFiles"></addBtn>
		</div>
		<div class="btns">
			<van-button @click="save" type="primary" size="large">保存</van-button>
		</div>
		<titleDialog v-if="showDialog" :title="dialogTitle" :cancelTxt="cancelBtn" :confirmTxt="confirmBtn" @confirm="confirm" @cancel="cancel"></titleDialog>
		<commonPicker ref="commonPickerQuarter" :typeList="newQuarterList" :title="title" :cols="cols1" @getTypeValue="getTypeValue"></commonPicker>
		<timePick @getTimeValue="getTimeValue" ref="timePick"></timePick>
		<tipDialog :isShow="showTips" :content="requireCont" @closeModal="showTips = false"></tipDialog>
	</div>
</template>

<script>
import titleDialog from "../components/titleDialog.vue";
import commonPicker from "../../../components/base/myCommonPicker.vue";
import timePick from "../../../components/base/timePick.vue";
import addBtn from "../appraiseNew/components/addBtn.vue";
import tipDialog from "../travelNegative/components/tipDialog.vue";
import api from "@/service/modules/appraiseNew.js";
import icon from "@/assets/appraise/icon_ts_gx@3x.png";
export default {
	components: {
		titleDialog,
		commonPicker,
		timePick,
		addBtn,
		tipDialog,
	},
	data() {
		return {
			showDialog: false,
			showTips: false,
			requireCont: "",
			dialogTitle: "",
			cancelBtn: "",
			confirmBtn: "",
      show: false,
			accidentName: "", //事故名称
			accidentDesc: "", // 事故处理情况
			isSave: "1", // 点击的是删除还是保存按钮 1删除2保存
			delItem: {}, // 选择删除的附件id
			selectQuarter: {},
			selectTime: {},
			fileResVOS: [], // 附件列表
			newQuarterList: [
				[
					{ id: "biggest", text: "特大涉旅安全事故" },
					{ id: "bigger", text: "重大涉旅安全事故" },
					{ id: "big", text: "较大涉旅安全事故" },
					{ id: "normal", text: "一般涉旅安全事故" },
					{ id: "others", text: "其他涉旅安全事故" },
				],
			],
			cols1: 1,
			title: "",
		};
	},
	created() {
		this.initData();
	},
	methods: {
		// 初始化
		initData() {
			this.$route.meta.title = this.$route.query.id
				? "编辑情况"
				: "新增情况";
			if (this.$route.query.id) {
				this.queryDetail();
			}
    },
		// 查询详情
		queryDetail() {
			let params = {
				id: this.$route.query.id,
			};
			api.querySaveDetail(params).then((res) => {
				if (res.ret == 0) {
					this.accidentName = res.data.accidentName;
					this.selectQuarter = {
						id: res.data.accidentLevel,
						text: res.data.accidentLevelCN,
					};
					this.selectTime = {
						name: res.data.accidentTime,
						value:
							res.data.accidentTime.slice(0, 4) +
							"-" +
							res.data.accidentTime.slice(5, 7) +
							"-" +
							res.data.accidentTime.slice(8, 10),
					};
					this.accidentDesc = res.data.accidentDesc;
					this.fileResVOS = res.data.fileResVOS;
				}
			});
		},
		// 上传附件回调
		getFiles(file) {
			this.fileResVOS.push(file[0]);
		},
		showTime() {
			this.$refs.timePick.showPicker();
		},
		showQuarter() {
			// 唤起事故等级选择组件
			this.$refs.commonPickerQuarter.showPicker();
		},
		getTimeValue(val) {
			this.selectTime = {
				name:
					val.split("-")[0] +
					"年" +
					val.split("-")[1] +
					"月" +
					val.split("-")[2] +
					"日",
				value: val,
			};
		},
		del(item) {
			this.dialogTitle = "是否确定删除附件";
			this.cancelBtn = "取消";
			this.confirmBtn = "删除";
			this.isSave = "1";
			this.delItem = item;
			this.showDialog = true;
		},
		// 保存
		save() {
			if (this.accidentName == "") {
				this.requireCont = "请填写“安全事故名称”";
				this.showTips = true;
				return;
			} else if (!this.selectQuarter.text) {
				this.requireCont = "请选择“事故级别”";
				this.showTips = true;
				return;
			} else if (!this.selectTime.value) {
				this.requireCont = "请选择“事故发生时间”";
				this.showTips = true;
				return;
			} else if (this.accidentDesc == "") {
				this.requireCont = "请填写“事故处理情况”";
				this.showTips = true;
				return;
			} else if (this.fileResVOS.length === 0) {
				this.requireCont = "请上传“相关附件”";
				this.showTips = true;
				return;
			}
			this.isSave = "2";
			(this.dialogTitle = "是否确定保存"),
				(this.cancelBtn = "取消"),
				(this.confirmBtn = "保存"),
				(this.showDialog = true);
		},
		// 弹窗确认回调
		confirm() {
			this.showDialog = false;
			if (this.isSave === "2") {
				this.saveAccident();
			} else {
				let index = this.fileResVOS.indexOf(this.delItem);
				this.fileResVOS.splice(index, 1);
			}
		},
		// 新增事故发生情况
		saveAccident() {
			const { area, quarter, year } = this.$route.query;
			let data = {
				id: this.$route.query.id,
				accidentDesc: this.accidentDesc,
				accidentLevel: this.selectQuarter.id,
				accidentName: this.accidentName,
				accidentTime: this.selectTime.value,
				area,
				quarter,
				year,
				fileResVOS: this.fileResVOS,
			};
			api.createTripAccident(data).then((res) => {
				if (res.ret === 0) {
					this.$Toast({
						message: data.id ? "更新成功" : "新增成功",
						icon,
					});
					setTimeout(() => {
						this.$router.back(-1);
					}, 2000);
				}
			});
		},
		// 弹窗失败回调
		cancel() {
			this.showDialog = false;
		},
		// 选中事故类型回调
		getTypeValue(value) {
			this.selectQuarter = value[0];
		},
	},
};
</script>

<style scoped lang="less">
.situation {
	padding: 9px 12px 0;
}
.accident {
	display: flex;
	justify-content: space-between;
	padding: 16px 0;
	height: 46px;
	border-bottom: 1px solid #ededed;
	.tip {
		color: #666;
		font-size: 14px;
	}
	.input input {
		color: #333;
		font-size: 14px;
		text-align: right;
	}
	.input input::-webkit-input-placeholder {
		font-size: 14px;
		color: #ccc;
		text-align: right;
	}
	.drop_down {
		span {
			margin-right: 4px;
			color: #ccc;
			font-size: 14px;
		}
		img {
			display: inline-block;
			width: 12px;
			height: 12px;
			vertical-align: text-top;
		}
		span.selected {
			color: #333;
			font-size: 14px;
		}
	}
}
.link {
	padding-bottom: 16px;
	border-bottom: 1px solid #ededed;
	.link_title {
		padding: 16px 0 12px;
		font-size: 14px;
		color: #666;
	}
	.content {
		.van-field {
			width: 351px;
      height: 120px;
      overflow: auto;
			background-color: #f5f5f5;
		}
	}
}
.btns {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	padding: 10px 12px;
	height: 60px;
	background: rgba(255, 255, 255, 1);
	box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.03);
	.van-button {
		width: 351px;
		height: 40px;
		background-color: #36b374;
	}
}
.upload_file {
	padding-bottom: 60px;
	background-color: #fff;
	.upload_tit {
		padding: 16px 0;
		font-size: 14px;
		color: #666;
	}
}
.file_item {
	display: flex;
	box-sizing: border-box;
	justify-content: space-between;
	align-items: center;
  padding-bottom: 15px;
	.file_msg {
		flex: 1;
		display: flex;
		align-items: center;
	}
	.file_msg img {
		margin-right: 12px;
		width: 34px;
		height: 38px;
	}
	.file_msg p {
		font-size: 14px;
		color: #333;
		span {
			line-height: 20px;
			word-break: break-word;;
		}
	}
	.file_size {
		font-size: 12px;
		color: #999;
	}
	.delImg {
		box-sizing: border-box;
		line-height: 38px;
		margin-left: 5px;
		margin-right: 10px;
	}
	.delImg img {
		width: 15px;
		height: 16px;
	}
}
.about_content{
     width:100%;
     position: relative;
     .content{
       width:100%;
       height:120px;
       font-size:14px;
       color:#323233;
       background-color: #f5f5f5;
       border:0;
       outline: none;
       border-radius: 3px;
       padding:16px;
       box-sizing: border-box;
       line-height: 1.3em;
    }
  }
</style>
